import EmptyRouter from '@/layout/EmptyRouter.vue';
import EmptyRouterAlive from '@/layout/EmptyRouterAlive.vue';
export default {
  path: 'quotationCenter',
  name: 'QuotationCenterManagement',
  component: EmptyRouterAlive,
  meta: {
    title: '报价模块',
  },
  children: [
    {
      path: 'Supplier',
      name: 'BusinessQuotationSupplier',
      component: EmptyRouter,
      redirect: 'supplier/index',
      meta: { title: '供应商报价', isCache: true },
      children: [
        {
          path: 'index',
          name: 'BusinessQuotationSupplier',
          component: () => import('@/views/center-business/QuotationCenter/supplier'),
          meta: { title: '供应商报价', isCache: true },
        },
        {
          path: 'details',
          name: 'BusinessQuotationDetails',
          component: () => import('@/views/center-business/QuotationCenter/details'),
          meta: { title: '报价明细', isCache: true },
        },
        {
          path: 'shippingCost',
          name: 'BusinessQuotationShippingCost',
          component: () => import('@/views/center-business/QuotationCenter/shippingCost'),
          meta: { title: '运费', isCache: true },
        },
        {
          path: 'otherCost',
          name: 'BusinessQuotationOtherCost',
          component: () => import('@/views/center-business/QuotationCenter/otherCost'),
          meta: { title: '其他费', isCache: true },
        },
        {
          path: 'trialCalculation',
          name: 'BusinessQuotationTrialCalculation',
          component: () => import('@/views/center-business/QuotationCenter/trialCalculation'),
          meta: { title: '试算', isCache: true },
        },
      ],
    },
    {
      path: 'Customer',
      name: 'BusinessQuotationCustomer',
      component: EmptyRouter,
      redirect: 'QuotationCustomer/index',
      meta: { title: '客户标准报价', isCache: true },
      children: [
        {
          path: 'index',
          name: 'BusinessQuotationCustomer',
          component: () => import('@/views/center-business/QuotationCustomer/Customer'),
          meta: { title: '客户标准报价', isCache: true },
        },
        {
          path: 'details',
          name: 'BusinessQuotationCustomerDetails',
          component: () => import('@/views/center-business/QuotationCustomer/details'),
          meta: { title: '报价明细', isCache: true },
        },
        {
          path: 'shippingCost',
          name: 'BusinessQuotationCustomerShippingCost',
          component: () => import('@/views/center-business/QuotationCustomer/shippingCost'),
          meta: { title: '运费', isCache: true },
        },
        {
          path: 'otherCost',
          name: 'BusinessQuotationCustomerOtherCost',
          component: () => import('@/views/center-business/QuotationCustomer/otherCost'),
          meta: { title: '其他费', isCache: true },
        },
        {
          path: 'trialCalculation',
          name: 'BusinessQuotationCustomerTrialCalculation',
          component: () => import('@/views/center-business/QuotationCustomer/trialCalculation'),
          meta: { title: '试算', isCache: true },
        },
      ],
    },
    {
      path: 'VIPCustomer',
      name: 'BusinessQuotationVIPCustomer',
      component: EmptyRouter,
      redirect: 'QuotationVIPCustomer/index',
      meta: { title: 'VIP客户报价', isCache: true },
      children: [
        {
          path: 'index',
          name: 'BusinessQuotationVIPCustomer',
          component: () => import('@/views/center-business/QuotationVIPCustomer/VIPCustomer'),
          meta: { title: 'VIP客户报价', isCache: true },
        },
      ],
    },
    {
      path: 'QuotationRate',
      name: 'BusinessFuelSurchargeRate',
      component: EmptyRouter,
      redirect: 'QuotationRate/index',
      meta: { title: '燃油附加费费率维护', isCache: true },
      children: [
        {
          path: 'index',
          name: 'BusinessFuelSurchargeRate',
          component: () => import('@/views/center-business/QuotationRate'),
          meta: { title: '燃油附加费费率维护', isCache: true },
        },
      ],
    },
  ],
};
